var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { stringify } from 'query-string';
import qs from 'qs';
import { formatApiError } from './utils.js';
import { API_LIST, AUTH_API_BASE_PARAMS, CANCEL_TOKEN_SOURCE_KEY, OTHER_CHAIN_AUTH_API_BASE_PARAMS } from './constants.js';
import { EtransferRequest } from '@etransfer/request';
export class BaseService {
    constructor() {
        this._request = new EtransferRequest();
    }
    setRequestConfig(key, value) {
        this._request.setConfig(key, value);
    }
    setRequestHeaders(key, value) {
        this._request.setHeaders(key, value);
    }
    getRequest() {
        return this._request;
    }
}
export class Services extends BaseService {
    getAuthToken(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.post(`/connect/token`, stringify(Object.assign(Object.assign({}, AUTH_API_BASE_PARAMS), params)), Object.assign(Object.assign({}, config), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }));
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getAuthToken error', false);
            }
        });
    }
    getOtherChainAuthToken(params, config) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.post(`/connect/token`, stringify(Object.assign(Object.assign({}, OTHER_CHAIN_AUTH_API_BASE_PARAMS), params)), Object.assign(Object.assign({}, config), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }));
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getAuthToken error', false);
            }
        });
    }
    getTokenList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.common.getTokenList, { params });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getTokenList error', false);
            }
        });
    }
    getTokenOption(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.common.getTokenOption, { params });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getDepositCalculate error', false);
            }
        });
    }
    getNetworkList(params, authToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const _requestConfig = { params, cancelTokenSourceKey: CANCEL_TOKEN_SOURCE_KEY.GET_NETWORK_LIST };
                if (authToken) {
                    _requestConfig.headers = { Authorization: authToken };
                }
                const res = yield this._request.send(API_LIST.common.getNetworkList, _requestConfig);
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getNetworkList error', true);
            }
        });
    }
    getTokenPrices(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.common.getTokenPrices, {
                    params,
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getTokenPrices error', true);
            }
        });
    }
    getDepositInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.deposit.getDepositInfo, {
                    params,
                    cancelTokenSourceKey: CANCEL_TOKEN_SOURCE_KEY.GET_DEPOSIT_INFO,
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getDepositInfo error', true);
            }
        });
    }
    getDepositCalculate(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.deposit.depositCalculator, {
                    params,
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getDepositCalculate error', false);
            }
        });
    }
    getWithdrawInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.withdraw.getWithdrawInfo, {
                    params,
                    cancelTokenSourceKey: CANCEL_TOKEN_SOURCE_KEY.GET_WITHDRAW_INFO,
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getWithdrawInfo error', true);
            }
        });
    }
    createWithdrawOrder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.withdraw.createWithdrawOrder, {
                    data: params,
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'createWithdrawOrder error', false);
            }
        });
    }
    // About History
    getRecordsList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.records.getRecordsList, { params });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getRecordsList error', false);
            }
        });
    }
    getRecordStatus(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const _requestConfig = {};
                if (params) {
                    _requestConfig.params = params;
                    _requestConfig.paramsSerializer = function (params) {
                        return qs.stringify(params, { arrayFormat: 'repeat' });
                    };
                }
                const res = yield this._request.send(API_LIST.records.getRecordStatus, _requestConfig);
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getRecordStatus error', false);
            }
        });
    }
    getRecordDetail(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.records.getRecordDetail, { query: id });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getRecordDetail error', false);
            }
        });
    }
    // About Registration
    checkEOARegistration(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.user.checkEOARegistration, { params });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'checkEOARegistration error', false);
            }
        });
    }
    checkRegistration(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.user.checkRegistration, { params });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'checkRegistration error', false);
            }
        });
    }
    // About Transfer
    getTokenNetworkRelation(params, authToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.transfer.getTokenNetworkRelation, {
                    params,
                    headers: {
                        Authorization: authToken || '',
                    },
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getTokenNetworkRelation error', false);
            }
        });
    }
    getTransferInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._request.send(API_LIST.transfer.getTransferInfo, {
                    params,
                    cancelTokenSourceKey: CANCEL_TOKEN_SOURCE_KEY.GET_TRANSFER_INFO,
                    headers: {
                        Authorization: '',
                    },
                });
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'getTransferInfo error', true);
            }
        });
    }
    createTransferOrder(params, authToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const _requestConfig = { data: params };
                if (authToken) {
                    _requestConfig.headers = { Authorization: authToken };
                }
                const res = yield this._request.send(API_LIST.transfer.createTransferOrder, _requestConfig);
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'createTransferOrder error', false);
            }
        });
    }
    updateTransferOrder(params, orderId, authToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const _requestConfig = { data: params, query: orderId };
                if (authToken) {
                    _requestConfig.headers = { Authorization: authToken };
                }
                const res = yield this._request.send(API_LIST.transfer.updateTransferOrder, _requestConfig);
                return res.data;
            }
            catch (error) {
                throw formatApiError(error, 'updateTransferOrder error', false);
            }
        });
    }
}
